import { Linkedin, Youtube } from "lucide-react";

const XLogo = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const socials = [
  { icon: Linkedin, href: "https://www.linkedin.com/in/cashivangimittal/", label: "LinkedIn", testid: "footer-social-linkedin" },
  { icon: XLogo, href: "https://x.com/CAShivangi_m", label: "X", testid: "footer-social-twitter" },
  { icon: Youtube, href: "https://www.youtube.com/@CAShivangiMittal", label: "YouTube", testid: "footer-social-youtube" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative pt-10 pb-12 border-t border-white/5">
      <div className="absolute inset-x-0 -top-px h-px"
           style={{ background: "linear-gradient(90deg, transparent, #16D1C8, #FF2D7A, transparent)" }} />
      <div className="container-x flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-xl overflow-hidden bg-black ring-1 ring-white/10">
            <img
              src="https://customer-assets.emergentagent.com/job_shivangi-digital/artifacts/z1cbny6n_619e7a1a0cf2c56a71b570e2.png"
              alt="Shivangi Mittal Logo"
              className="w-full h-full object-cover"
            />
          </span>
          <div className="text-sm">
            <div className="text-white font-medium">Shivangi Mittal</div>
            <div className="text-white/45 text-xs">© {new Date().getFullYear()} · All rights reserved</div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={s.testid}
              aria-label={s.label}
              className="w-9 h-9 grid place-items-center rounded-full border border-white/10 text-white/60 hover:text-white hover:border-teal-400/60 transition-all"
            >
              <s.icon size={14} />
            </a>
          ))}
        </div>

        <div className="text-xs text-white/40 tracking-wider uppercase">
          Tax · Tech · Transform
        </div>
      </div>
    </footer>
  );
};
